export default __webpack_public_path__ + "static/media/hair_clips.a2a84366.png";